<template>
  <div class="signin">
    <van-sticky>
      <van-nav-bar title="找回密码" left-arrow @click-left="goback()" />
    </van-sticky>
    <div class="bg">
      <img src="/static/images/login_bg.png" />
    </div>

    <div class="login_form">
      <div class="reminder">请输入您的手机号码，接收验证码找回你的密码</div>
      <van-form label-width="60" :show-error="false" @submit="onSubmit">
        <van-cell-group>
          <van-field
            v-model="user.telephone"
            label="手机号"
            placeholder="请输入您手机号"
            :rules="[
              { required: true, message: '请输入手机号码' },
              { pattern: /^1[3456789]\d{9}$/, message: '手机号码格式错误！' },
            ]"
          >
            <template #label>
              <div class="fs14">
                +{{ headerNum }}
                <!-- <van-icon name="arrow-down" color="#4A4A4A" /> -->
              </div>
            </template>

            <template #button>
              <van-button
                native-type="button"
                size="small"
                color="#195ED7"
                round
                @click="getCode()"
                >{{ codeCentent }}</van-button
              >
            </template>
          </van-field>

          <van-field
            v-model="user.sendcode"
            center
            clearable
            label="验证码"
            placeholder="请输入短信验证码"
            :rules="[{ required: true, message: '请输入短信验证码' }]"
          >
          </van-field>
          <van-field
            v-model="user.password"
            type="password"
            label="新密码"
            maxlength="6"
            placeholder="请输入新设置的密码"
            :rules="[{ required: true, message: '请输入新设置的密码' }]"
          />
          <van-field
            v-model="user.password1"
            type="password"
            label="重复密码"
            maxlength="6"
            placeholder="请再次输入密码"
            :rules="[{ required: true, message: '请再次输入密码' }]"
          />
        </van-cell-group>

        <div class="form_btn">
          <van-button
            round
            block
            color="#195ED7"
            type="info"
            native-type="submit"
            :disabled="isLoading"
            :loading="isLoading"
            loading-text="正在提交ing..."
            >提交</van-button
          >
        </div>
      </van-form>
    </div>

    <van-action-sheet v-model="show" :actions="actions" @select="onSelect" />
  </div>
</template>

<script>
import { Button } from "vant";
import { NavBar } from "vant";
import { Form, Field, CellGroup } from "vant";
import { RadioGroup, Radio } from "vant";
import { Icon } from "vant";
import { ActionSheet, Notify } from "vant";

export default {
  data() {
    const actions = [{ name: "001" }, { name: "002" }, { name: "003" }];
    const onSelect = (item) => {
      // 默认情况下点击选项时不会自动收起
      // 可以通过 close-on-click-action 属性开启自动收起
      this.show = false;
      this.headerNum = item.name;
    };
    return {
      user: {
        telephone: "",
        username: "",
        sendcode: "",
        receivecode: "",
        password: "",
        password1: "",
        type: 3,
      },
      
      codeCentent: "获取验证码",
      totalTime: 60, //倒计时
      canClick: true,

      isLoading: false,
      showPicker: false,
      show: false,
      headerNum: 86,
      actions,
      onSelect,
    };
  },
  components: {
    [Button.name]: Button,
    [NavBar.name]: NavBar,
    [Form.name]: Form,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Icon.name]: Icon,
    [ActionSheet.name]: ActionSheet,
  },
  methods: {
    //返回上一页
    goback() {
      if (window.history.length <= 1) {
        this.$router.push({ path: "/" });
        return false;
      } else {
        this.$router.go(-1);
      }
    },

    //获取验证码
    getCode() {
      var that = this;

      if (!that.canClick) {
        return;
      }

      if (
        that.user.telephone === "" ||
        !/^1[3456789]\d{9}$/.test(that.user.telephone)
      ) {
        Notify({ type: "danger", message: "手机号码格式错误！" });
        return;
      }

      that.canClick = false;
      that.codeCentent = that.totalTime + "s后重新发送";

      let clock = window.setInterval(() => {
        that.totalTime--;
        that.codeCentent = that.totalTime + "s后重新发送";
        if (that.totalTime < 0) {
          //当倒计时小于0时清除定时器
          window.clearInterval(clock); //关闭
          that.codeCentent = "重新发送验证码";
          that.totalTime = 60;
          that.canClick = true; //这里重新开启
        }
      }, 1000);

      that.$api
        .getCodeAPI(that.user)
        .then(function (res) {
          if (res.data.code === 200) {
            that.user.receivecode = res.data.data;
          }
        })
        .catch(function (err) {
          console.log("error");
        });
    },

    //点击立即注册
    onSubmit() {
      var that = this;
      that.isLoading = true;
      // 验证数据是否正确
      if (that.user.sendcode != that.user.receivecode) {
        Notify({ type: "danger", message: "验证码错误，请重新输入！" });
        that.isLoading = false;
      } else if (that.user.password != that.user.password1) {
        Notify({ type: "danger", message: "两次密码不一致，请重新输入！" });
        that.isLoading = false;
      } else {
        that.user.username = that.user.telephone;
        console.log("user", that.user);
        that.$api
          .changePasswordAPI({
            telephone: that.user.telephone,
            password: that.user.password,
          })
          .then(function (res) {
            if (res.data.code === 200) {
              Notify({
                type: "success",
                message: "修改成功，请去返回登录！",
                onClose() {
                  that.$router.back();
                },
              });
            } else {
              Notify({ type: "warning", message: res.data.message });
            }
            that.isLoading = false;
          })
          .catch(function (err) {
            console.log("error");
            that.isLoading = false;
          });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.signin {
  display: flex;
  flex-direction: column;

  .bg {
    position: relative;
    img {
      width: 100%;
      margin-top: -50px;
    }

    .login_tag {
      position: absolute;
      bottom: 20%;
      font-size: 14px;
      text-align: center;
      color: #fff;
    }
  }

  .login_form {
    padding: 0px 20px;
    height: auto;
    margin-top: 30px;

    .form_tag {
      display: flex;
      justify-content: space-between;
      padding: 0px 20px;
    }

    .reminder {
      color: rgba(74, 74, 74, 100);
      font-size: 14px;
      margin-bottom: 40px;
      margin-left: 15px;
    }

    .van-cell {
      display: flex;
      align-items: center;
    }
  }

  .form_btn {
    margin: 40px 20px;
    border-radius: 1000px;
    box-shadow: 0px 5px 10px rgba(25, 94, 215, 0.5);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/login/forgotPwd.vue